import { useNavigate } from 'react-router-dom';

import { PATH } from 'constants/path';

export const useTrainerLayoutController = () => {
  const navigate = useNavigate();

  const onClickAdd = () => {
    navigate(`${PATH.TRAINERS}/${PATH.TRAINER_FULL_TIME_ADD}`);
  };

  return {
    onClickAdd,
  };
};
